module.exports = __webpack_public_path__ + "static/media/PC6-3.1848ad1d.jpg";